import { EventDisplayData } from "../../../../../../../../../common/sesh_types";
import { CalendarEventDisplayData } from "../components/calendar_page";

// TODO: use query item
export function isSeshEvent(
	event: CalendarEventDisplayData
): event is EventDisplayData {
	return (event as EventDisplayData).message_id !== undefined;
}
